import { IVillageSchema } from '../types';

export enum FVillageBuildingsType {
  Unexpected = 0,
  /**
   * Дом
   */
  House = 1,
  /**
   * Таунхаус
   */
  Townhouse = 4,
  /**
   * Участок
   */
  Land = 3,
}

export function getVillageBuildingTypes(village: IVillageSchema): string {
  const categorySet = village.newobjectCategorySet;
  const buildingTypes: number[] = [];

  if (categorySet) {
    if (categorySet.cottage || categorySet.lowrisehouse) {
      buildingTypes.push(FVillageBuildingsType.House);
    }
    if (categorySet.landplot) {
      buildingTypes.push(FVillageBuildingsType.Land);
    }
    if (categorySet.townhouse) {
      buildingTypes.push(FVillageBuildingsType.Townhouse);
    }

    return buildingTypes.join(',');
  } else {
    return FVillageBuildingsType.Unexpected.toString();
  }
}
